import React from "react";
import { Link } from "react-router-dom";
import "./eligibility-criteria.css";
import { FaCheckCircle, FaTimesCircle, FaCalendarAlt, FaIdCardAlt, FaUniversity, FaMoneyBillAlt } from "react-icons/fa";

const criteriaData = [
  {
    icon: <FaCalendarAlt />,
    text: "Age must be between 21 and 60 years old.",
    status: true,
  },
  {
    icon: <FaIdCardAlt />,
    text: "Must be a resident of India with valid ID proof (Aadhaar/PAN).",
    status: true,
  },
  {
    icon: <FaUniversity />,
    text: "Salaried or Self-Employed with a stable source of income.",
    status: true,
  },
  {
    icon: <FaMoneyBillAlt />,
    text: "Minimum monthly net income of ₹15,000 or more.",
    status: true,
  },
  {
    icon: <FaTimesCircle />,
    text: "We currently do not accept applicants with a default credit history.",
    status: false,
  },
];

const EligibilityCriteria = () => {
  return (
    <section className="ec-wrap">
      <div className="ec-container">
        {/* LEFT SIDE: Title & Introduction */}
        <div className="ec-left">
          <div className="ec-eyebrow">Quick Check</div>
          <h2 className="ec-title">
            Are You <span className="ec-highlight">Eligible for Instant</span>  Cash?
          </h2>
          <p className="ec-sub">
            Review the simple criteria below. If you meet these requirements, you're just minutes away from getting approved for your loan.
          </p>
          <Link to="/apply-now">
  <button className="ec-btn-primary">Apply Now</button>
</Link>

        </div>

        {/* RIGHT SIDE: Criteria List */}
        <div className="ec-right">
          <div className="ec-criteria-list">
            {criteriaData.map((item, index) => (
              <div key={index} className="ec-criteria-item">
                <div 
                  className={`ec-icon-box ${item.status ? 'pass' : 'fail'}`}
                  style={{ 
                    '--icon-color': item.status ? '#00ff7f' : '#ff3333' // Neon Green for Pass, Red for Fail
                  }}
                >
                  {item.status ? <FaCheckCircle /> : <FaTimesCircle />}
                </div>
                <p className="ec-criteria-text">{item.text}</p>
              </div>
            ))}
          </div>
          
          <p className="ec-note">
            *Eligibility is subject to final digital verification and lender terms.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EligibilityCriteria;